const PbxxRecord = require('../pbxx_record')

module.exports = class Widget extends PbxxRecord {
  static get class_name() {
    return 'Widget'
  }
}
